import Cards from "../../../Cards/Cards";
import classes from "./Final.module.scss";

const data = [
  {
    number: "01.",
    title: "Полное отсутствие установленных целей в статистических системах",
  },
  {
    number: "02.",
    title: "Общий трафик порядка 6 000 визитов в месяц, трафик с SEO 1 700 визитов в месяц",
  },
  {
    number: "03.",
    title: "Отсутствие\n работы с ЦА,\n которую мы\n определили",
  },
  {
    number: "04.",
    title: "Отсутствие\n работы по\n каналу\n email-маркетинг",
  },
  {
    number: "05.",
    title: "Крайне\n некачественная\n настройка\n контекстной\n рекламы\n",
  },
]

const Final = () => {
  return (
    <div className={classes.Final}>
        <div className={classes.Title}>Итого на начало работ</div>
        <div className={classes.List}>
          {data.map( (elem, i) => {
              return <Cards
                   number={elem.number}
                   key={i}
                   title={elem.title}
                   customClass={classes.Item}
                   />
          })}
        </div>
    </div>
  )
}

export default Final;